document.addEventListener('DOMContentLoaded', function () {
  document.body.classList.add('js-ready');

  // ---- Hero banner slideshow ----
  document.querySelectorAll('.hero-banner').forEach(function (hero) {
    var slides = hero.querySelectorAll('.hero-banner__slide');
    if (!slides.length) return;
    var current = 0;
    var counter = hero.querySelector('.hero-banner__counter .current');
    var autoplay = hero.dataset.autoplay === 'true';
    var interval = parseInt(hero.dataset.interval, 10) || 5000;
    var timer;

    function show(index) {
      slides[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (counter) counter.textContent = current + 1;
    }

    function next() { show(current + 1); }
    function prev() { show(current - 1); }

    function start() {
      if (!autoplay || slides.length < 2) return;
      timer = setInterval(next, interval);
    }
    function stop() { clearInterval(timer); }

    var nextBtn = hero.querySelector('.hero-banner__next');
    var prevBtn = hero.querySelector('.hero-banner__prev');
    var pauseBtn = hero.querySelector('.hero-banner__pause');
    var paused = false;

    if (nextBtn) nextBtn.addEventListener('click', function () { stop(); next(); if (!paused) start(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { stop(); prev(); if (!paused) start(); });
    if (pauseBtn) pauseBtn.addEventListener('click', function () {
      paused = !paused;
      if (paused) { stop(); pauseBtn.innerHTML = '&#9654;'; }
      else { start(); pauseBtn.innerHTML = '&#10074;&#10074;'; }
    });

    start();
  });

  // ---- Compare product selects ----
  document.querySelectorAll('.compare-products__select').forEach(function (select) {
    select.addEventListener('change', function () {
      // Hook point for loading product comparison data.
    });
  });

  // ---- Scroll-reveal animation ----
  var targets = document.querySelectorAll('[data-animate]');
  if (targets.length) {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
      targets.forEach(function (el) { observer.observe(el); });
    } else {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  // ---- Animated stat counters (count up from 0 when scrolled into view) ----
  var statEls = document.querySelectorAll('.stat__value[data-count-to]');
  if (statEls.length) {
    var parseCountValue = function (raw) {
      var match = (raw || '').trim().match(/^(\D*)([\d]*\.?[\d]+)(.*)$/);
      if (!match) return null;
      var numStr = match[2];
      return {
        prefix: match[1],
        suffix: match[3],
        decimals: (numStr.split('.')[1] || '').length,
        target: parseFloat(numStr)
      };
    };

    var setZeroState = function (el, parsed) {
      el.textContent = parsed.prefix + (0).toFixed(parsed.decimals) + parsed.suffix;
    };

    var animateCount = function (el) {
      var parsed = parseCountValue(el.getAttribute('data-count-to'));
      if (!parsed || isNaN(parsed.target)) return;
      var duration = 1400;
      var startTime = null;

      var frame = function (ts) {
        if (!startTime) startTime = ts;
        var progress = Math.min((ts - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = parsed.prefix + (parsed.target * eased).toFixed(parsed.decimals) + parsed.suffix;
        if (progress < 1) {
          requestAnimationFrame(frame);
        } else {
          el.textContent = parsed.prefix + parsed.target.toFixed(parsed.decimals) + parsed.suffix;
        }
      };
      requestAnimationFrame(frame);
    };

    statEls.forEach(function (el) {
      var parsed = parseCountValue(el.getAttribute('data-count-to'));
      if (parsed && !isNaN(parsed.target)) setZeroState(el, parsed);
    });

    if ('IntersectionObserver' in window) {
      var statObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCount(entry.target);
            statObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4, rootMargin: '0px 0px -40px 0px' });
      statEls.forEach(function (el) { statObserver.observe(el); });
    } else {
      statEls.forEach(function (el) { el.textContent = el.getAttribute('data-count-to'); });
    }
  }

  // ---- Header icon panels: tap-to-toggle (hover alone isn't reliable on touch) ----
  var headerGroups = document.querySelectorAll('.header-icon-group');
  if (headerGroups.length) {
    headerGroups.forEach(function (group) {
      var trigger = group.querySelector('.site-header__icon-btn');
      if (!trigger) return;
      trigger.addEventListener('click', function (e) {
        var willOpen = !group.classList.contains('is-open');
        headerGroups.forEach(function (other) { other.classList.remove('is-open'); });
        if (willOpen) {
          group.classList.add('is-open');
          e.stopPropagation();
        }
      });
    });
    document.addEventListener('click', function (e) {
      headerGroups.forEach(function (group) {
        if (!group.contains(e.target)) group.classList.remove('is-open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        headerGroups.forEach(function (group) { group.classList.remove('is-open'); });
      }
    });
  }

  // ---- Sticky header shadow on scroll ----
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 8) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---- Cart page: quantity steppers + remove line ----
  var cartForm = document.querySelector('.cart-form');
  if (cartForm) {
    cartForm.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
      var input = stepper.querySelector('.qty-stepper__input');
      var decrease = stepper.querySelector('[data-qty-decrease]');
      var increase = stepper.querySelector('[data-qty-increase]');
      if (!input) return;

      function setValue(value) {
        var next = Math.max(0, value);
        input.value = next;
        cartForm.submit();
      }

      if (decrease) {
        decrease.addEventListener('click', function () {
          setValue((parseInt(input.value, 10) || 0) - 1);
        });
      }
      if (increase) {
        increase.addEventListener('click', function () {
          setValue((parseInt(input.value, 10) || 0) + 1);
        });
      }
    });

    cartForm.querySelectorAll('[data-cart-remove]').forEach(function (removeBtn) {
      removeBtn.addEventListener('click', function () {
        var row = removeBtn.closest('.cart-item');
        var input = row && row.querySelector('.qty-stepper__input');
        if (input) {
          input.value = 0;
          cartForm.submit();
        }
      });
    });
  }
});

// IGNITE product/gallery enhancements
(function () {
  document.addEventListener('click', function (event) {
    var wishlist = event.target.closest('.product-card__wishlist');
    if (wishlist) {
      wishlist.classList.toggle('is-active');
      wishlist.setAttribute('aria-pressed', wishlist.classList.contains('is-active') ? 'true' : 'false');
    }

    var thumb = event.target.closest('[data-product-thumb]');
    if (thumb) {
      var gallery = thumb.closest('[data-product-gallery]');
      var main = gallery && gallery.querySelector('[data-product-main-image]');
      if (main && thumb.dataset.src) main.src = thumb.dataset.src;
      if (gallery) gallery.querySelectorAll('[data-product-thumb]').forEach(function (item) { item.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    }
  });

  document.querySelectorAll('[data-product-variant]').forEach(function (select) {
    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      var price = select.closest('.product-info') && select.closest('.product-info').querySelector('[data-product-price]');
      if (price && option && option.dataset.price) price.textContent = option.dataset.price;
    });
  });
})();


(function(){
  function qs(s,r){return (r||document).querySelector(s)}
  function qsa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
  var cart=[];
  function money(n){return '$'+Number(n).toFixed(2)}
  function toast(msg){var t=qs('[data-ig-toast]');if(!t)return;t.textContent=msg;t.hidden=false;clearTimeout(t._timer);t._timer=setTimeout(function(){t.hidden=true},1700)}
  function updateCart(){
    var list=qs('[data-ig-cart-items]'),total=0;if(!list)return;
    if(!cart.length){list.innerHTML='<div class="ig-demo-cart__empty"><strong>Your cart is empty</strong><p>Open a product and add it to preview the cart.</p></div>'}
    else{list.innerHTML=cart.map(function(x,i){total+=x.price;return '<div class="ig-demo-cart__item"><img src="'+x.image+'" alt=""><div><strong>'+x.name+'</strong><span>'+x.variant+' · '+money(x.price)+'</span></div><button type="button" class="ig-demo-cart__remove" data-ig-remove="'+i+'" aria-label="Remove">×</button></div>'}).join('')}
    var out=qs('[data-ig-cart-total]');if(out)out.textContent=money(total);
    qsa('[data-ig-cart-count]').forEach(function(el){el.textContent=cart.length;el.classList.toggle('is-visible',cart.length>0)})
  }
  function openCart(){updateCart();var c=qs('[data-ig-cart]');if(c)c.hidden=false}
  function closeCart(){var c=qs('[data-ig-cart]');if(c)c.hidden=true}
  function openSearch(){var s=qs('[data-ig-search]');if(s){s.hidden=false;setTimeout(function(){var i=qs('input',s);if(i)i.focus()},30)}}
  function closeSearch(){var s=qs('[data-ig-search]');if(s)s.hidden=true}
  function openProduct(el){
    var m=qs('[data-ig-product]');if(!m)return;
    var name=el.getAttribute('data-name')||'IGNITE Device',price=el.getAttribute('data-price')||'0',image=el.getAttribute('data-image')||'',category=el.getAttribute('data-category')||'Premium technology';
    qs('[data-ig-p-name]',m).textContent=name;qs('[data-ig-p-price]',m).textContent=money(price);qs('[data-ig-p-image]',m).src=image;qs('[data-ig-p-image]',m).alt=name;qs('[data-ig-p-category]',m).textContent=category;qs('[data-ig-add]',m).setAttribute('data-name',name);qs('[data-ig-add]',m).setAttribute('data-price',price);qs('[data-ig-add]',m).setAttribute('data-image',image);m.hidden=false;
  }
  function closeProduct(){var m=qs('[data-ig-product]');if(m)m.hidden=true}
  function smoothTo(sel){var el=qs(sel);if(el)el.scrollIntoView({behavior:'smooth',block:'start'})}
  document.addEventListener('click',function(e){
    var t=e.target.closest&&e.target.closest('[data-ig-product-open]');if(t){e.preventDefault();openProduct(t);return}
    t=e.target.closest&&e.target.closest('[data-ig-product-close]');if(t){e.preventDefault();closeProduct();return}
    t=e.target.closest&&e.target.closest('[data-ig-add]');if(t){e.preventDefault();var sel=qs('[data-ig-p-variant]');cart.push({name:t.getAttribute('data-name'),price:Number(t.getAttribute('data-price')||0),image:t.getAttribute('data-image'),variant:sel?sel.value:'Standard'});updateCart();closeProduct();toast('Added to demo cart');return}
    t=e.target.closest&&e.target.closest('[data-ig-cart-open]');if(t){e.preventDefault();openCart();return}
    t=e.target.closest&&e.target.closest('[data-ig-cart-close]');if(t){e.preventDefault();closeCart();return}
    t=e.target.closest&&e.target.closest('[data-ig-remove]');if(t){e.preventDefault();cart.splice(Number(t.getAttribute('data-ig-remove')),1);updateCart();return}
    t=e.target.closest&&e.target.closest('[data-ig-search-open]');if(t){e.preventDefault();openSearch();return}
    t=e.target.closest&&e.target.closest('[data-ig-search-close]');if(t){e.preventDefault();closeSearch();return}
    t=e.target.closest&&e.target.closest('[data-ig-nav]');if(t){e.preventDefault();var sel=t.getAttribute('href');if(sel&&sel.charAt(0)==='#')smoothTo(sel);qsa('.header-icon-group').forEach(function(g){g.classList.remove('is-open')});return}
    t=e.target.closest&&e.target.closest('[data-ig-wishlist]');if(t){e.preventDefault();t.classList.toggle('is-active');t.setAttribute('aria-pressed',t.classList.contains('is-active')?'true':'false');toast(t.classList.contains('is-active')?'Saved to wishlist':'Removed from wishlist');return}
    t=e.target.closest&&e.target.closest('[data-ig-account]');if(t){e.preventDefault();var a=qs('[data-ig-account-card]');if(a)a.hidden=!a.hidden;return}
    t=e.target.closest&&e.target.closest('[data-ig-checkout]');if(t){e.preventDefault();toast('Demo checkout — no order created');return}
  });
  document.addEventListener('submit',function(e){
    if(e.target.matches('[data-ig-search-form]')){e.preventDefault();var q=qs('input',e.target).value.trim();closeSearch();smoothTo('#products');toast(q?'Showing demo results for “'+q+'”':'Showing all products');}
    if(e.target.matches('[data-ig-newsletter]')){e.preventDefault();var out=qs('[data-ig-news-success]');if(out){out.hidden=false;out.textContent='Thanks — this is a demo signup.'}e.target.reset()}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeSearch();closeCart();closeProduct();var a=qs('[data-ig-account-card]');if(a)a.hidden=true}});
  qsa('.category-tile').forEach(function(tile){tile.addEventListener('click',function(e){e.preventDefault();smoothTo('#products')})});
  qsa('.marquee__item').forEach(function(item){item.addEventListener('click',function(e){e.preventDefault();smoothTo('#products')})});
  updateCart();
})();
